import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const Button = ({
  children, onClick, variant = 'primary', size = 'md',
  loading = false, disabled = false, type = 'button', className = '', icon: Icon
}) => {
  const base = 'inline-flex items-center gap-2 font-semibold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary:   'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500',
    secondary: 'bg-gray-100 hover:bg-gray-200 text-gray-700 focus:ring-gray-400',
    danger:    'bg-red-500 hover:bg-red-600 text-white focus:ring-red-400',
    ghost:     'bg-transparent hover:bg-gray-100 text-gray-600 focus:ring-gray-400',
    success:   'bg-green-500 hover:bg-green-600 text-white focus:ring-green-400',
  };
  const sizes = {
    sm:  'px-3 py-1.5 text-xs',
    md:  'px-4 py-2 text-sm',
    lg:  'px-6 py-3 text-base',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${base} ${variants[variant]} ${sizes[size]} ${(disabled || loading) ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      {loading ? <LoadingSpinner size="sm" color="text-current" /> : Icon && <Icon size={16} />}
      {children}
    </button>
  );
};

export default Button;
